import React from "react";
import { motion } from "framer-motion";
import { LOGO_URL, COURSE } from "../../data/course";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-[#293891]/10 pt-20">
      <div className="pointer-events-none absolute bottom-0 left-1/2 h-[300px] w-[600px] -translate-x-1/2 glow-blue opacity-40" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col items-start justify-between gap-10 pb-14 md:flex-row md:items-center">
          <div className="max-w-md">
            <img src={LOGO_URL} alt="ExcellenC" className="h-10 w-auto" />
            <p className="mt-6 text-sm leading-relaxed text-[#566076]">
              The AI-Powered Data Analytics Professional Program — live mentorship, real projects, and a career team that stays until you succeed.
            </p>
          </div>
          <div className="flex flex-col gap-3 md:items-end">
            <span className="text-xs uppercase tracking-[0.24em] text-[#566076]">{COURSE.tagline}</span>
          </div>
        </div>

        {/* Massive brand wordmark */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="border-t border-[#293891]/10 py-10"
        >
          <div className="font-display text-[16vw] font-semibold leading-none tracking-tighter text-[#293891]/[0.06] md:text-[13vw]">
            ExcellenC
          </div>
        </motion.div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-[#293891]/10 py-8 text-xs text-[#64748b] md:flex-row">
          <span>© {new Date().getFullYear()} ExcellenC. All rights reserved.</span>
          <span>Towards Growth — Digital Course Brochure</span>
        </div>
      </div>
    </footer>
  );
}
